import React, { useEffect, useRef } from 'react';
import bootcampBadge from '../../images/Participation_Shape_copy_3_2.png';

const SKILLS = {
  'Tech I Use':    ['React', 'JavaScript', 'HTML & CSS', 'Node.js', 'REST APIs'],
  'I Build For':   ['Contractors & Trades', 'Landscapers', 'Local Shops', 'Restaurants', 'Service Businesses', 'Freelancers'],
  'You Can Expect':['Fast Turnaround', 'Mobile-Ready', 'Honest Pricing', 'No Runaround'],
};

const About = () => {
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('visible');
      }),
      { threshold: 0.15 }
    );
    const els = revealRefs.current;
    els.forEach((el) => el && observer.observe(el));
    return () => els.forEach((el) => el && observer.unobserve(el));
  }, []);

  const ref = (i) => (el) => { revealRefs.current[i] = el; };

  return (
    <section id="about" className="section">
      <div className="section-header reveal" ref={ref(0)}>
        <span className="section-num">01.</span>
        <h2 className="section-title">About Me</h2>
        <div className="section-line" />
      </div>

      <div className="about-grid">
        <div className="about-text reveal" ref={ref(1)}>
          <p>
            I'm <span className="about-highlight">Taylor</span>, a web developer from Hillsborough, NC.
            I build websites for the kind of businesses that keep this area running -
            contractors, landscapers, local shops, and anyone who needs a solid online
            presence without dealing with some big agency that doesn't know your name.
          </p>
          <p>
            The tech behind what I build is the same stuff powering the biggest sites
            on the internet. You don't need to know any of that -
            <span className="about-highlight"> that's my job</span>. Yours is running your business.
            I'll make sure the web side of it looks sharp, loads fast, and actually brings people in.
          </p>
          <p>
            And unlike most developers, I've spent years in the field - landscaping, handyman work, the whole deal.
            I'm not just a guy who codes. <span className="about-highlight">I know what it's like to run a service business</span>,
            and that makes a real difference in how I build for one.
          </p>
          <p>
            Most projects are live in <span className="about-highlight">just a few days</span>.
            Fair prices, straight talk, real results.
          </p>
          <div className="bootcamp-badge">
            <img src={bootcampBadge} alt="UNC Chapel Hill Full Stack Coding Boot Camp badge" />
            <span className="bootcamp-label">Certified · University of North Carolina at Chapel Hill</span>
          </div>
        </div>

        <div className="skills-panel reveal reveal-delay-1" ref={ref(2)}>
          {Object.entries(SKILLS).map(([category, tags]) => (
            <div key={category}>
              <p className="skill-group-label">{category.replace(/_/g, ' ')}</p>
              <div className="skill-tags">
                {tags.map((tag) => (
                  <span key={tag} className="skill-tag">{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
